import * as React from 'react'
import {
  WithStyles,
  createStyles,
  Button,
  CircularProgress
} from '@material-ui/core'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import withStyles from '@material-ui/core/styles/withStyles'
import green from '@material-ui/core/colors/green'
import Tooltip from '@material-ui/core/Tooltip'

export interface ISubmitButtonProps extends WithStyles<typeof styles> {
  isDisabled?: boolean
  isLoading?: boolean
  loadingText?: string
}

const SubmitButton: React.SFC<ISubmitButtonProps> = props => {
  const { isDisabled, isLoading, classes, children } = props
  const loadingText = props.loadingText || 'Submitting...'

  // id = "btnPayment" is required - see OrderFormContainer comments for more info
  return (
    <Tooltip
      placement="top"
      title={
        isDisabled
          ? 'Cannot submit form until all fields are filled in correctly'
          : ''
      }>
      <div className={classes.wrapper}>
        <Button
          id="btnPayment"
          size="large"
          variant="contained"
          color="primary"
          type="submit"
          disabled={isLoading || isDisabled}>
          {isLoading ? loadingText : children}
        </Button>
        {isLoading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </Tooltip>
  )
}

const styles = (theme: Theme) =>
  createStyles({
    wrapper: {
      margin: theme.spacing.unit,
      position: 'relative'
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    }
  })

export default withStyles(styles)(SubmitButton)



// WEBPACK FOOTER //
// ./src/components/shared/SubmitButton.tsx